export function getM1CalculatorUrl(calculatorId: string) {
  return `/api/m1/sso?backUrl=${encodeURIComponent(
    location.href
  )}&deepPath=${encodeURIComponent("/calculator/" + calculatorId)}`;
}
